import type { BoxProps } from '@mui/material/Box';

import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

import { varTap, varHover, transitionTap } from 'src/components/animate';

// ----------------------------------------------------------------------

type AccountButtonProps = BoxProps & {
  photoURL?: string;
  displayName?: string;
  email?: string;
  /**
   * 아바타 옆에 **이름·이메일을 펼지** — 기본은 아니다(아바타만).
   *
   * 🚨 **머리글에는 펴지 않는다.** 공개 지면에 이메일을 늘어놓으면 화면을 같이 보거나
   *   캡처할 때 그대로 노출되고, 읽는 사람에게 쓸모도 없다. 거기서 필요한 것은
   *   「로그인돼 있다」와 「들어가는 길」뿐이고, 길은 옆의 워크스페이스 단추가 쥔다.
   * 🔑 펴는 자리는 **일부러 연 개인 메뉴** 하나다(모바일 내비 서랍).
   */
  showIdentity?: boolean;
};

export function AccountButton({
  photoURL,
  displayName,
  email,
  sx,
  showIdentity = false,
  ...other
}: AccountButtonProps) {
  return (
    <Box
      component={m.div}
      whileTap={varTap(0.96)}
      whileHover={varHover(1.04)}
      transition={transitionTap()}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
        ...sx,
      }}
      {...other}
    >
      <Avatar src={photoURL} alt={displayName} sx={{ width: 40, height: 40, flexShrink: 0 }}>
        {displayName?.charAt(0).toUpperCase()}
      </Avatar>

      {showIdentity && (
      <Box
        sx={{
          minWidth: 0,
          flex: 1,
          display: { xs: 'none', md: 'block' },
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            color: 'text.primary',
            fontWeight: 600,
            lineHeight: 1.2,
          }}
        >
          {displayName}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            lineHeight: 1.2,
          }}
        >
          {email}
        </Typography>
      </Box>
      )}
    </Box>
  );
}
